import { Outlet } from "react-router-dom";
import { Stack } from "@/core/components/ui/stack/stack";
import PayrollSettingsNavigation from "./payroll-settings-navigation";

// Keep the roster content layout while sharing product-aware Settings navigation.
const PayrollSettings = () => (
  <Stack direction="row" gap="none" fullWidth className="h-[calc(100vh-67px)]">
    <PayrollSettingsNavigation />
    <Stack gap="none" className="h-full min-w-0 flex-1 overflow-hidden">
      <Outlet />
    </Stack>
  </Stack>
);

export default PayrollSettings;
